import React from "react";
import { CreditCard, Settings, ShieldCheck, Truck } from "lucide-react";
import { AdminPageHeader, Badge, Button, ListRow, Page, Panel, StatCard, StatGrid } from "../AdminKit";

const settings = [
  { name: "기본 배송비", value: "₩ 3,000", status: "활성" },
  { name: "무료배송 기준", value: "₩ 30,000 이상", status: "활성" },
  { name: "반품 가능 기간", value: "7일", status: "활성" },
  { name: "정품 검수 프로세스", value: "필수", status: "활성" },
];

export default function AdminManagement() {
  return (
    <Page>
      <AdminPageHeader title="운영 설정" description="배송, 결제, 보안, 반품 정책 등 쇼핑몰 운영 기준을 관리합니다." />
      <StatGrid>
        <StatCard><Settings size={24} /><span>운영 정책</span><strong>24개</strong></StatCard>
        <StatCard><Truck size={24} /><span>배송사 연동</span><strong>3개</strong></StatCard>
        <StatCard><CreditCard size={24} /><span>결제 수단</span><strong>6개</strong></StatCard>
        <StatCard><ShieldCheck size={24} /><span>보안 상태</span><strong>정상</strong></StatCard>
      </StatGrid>
      <Panel>
        <header><h2>주요 운영 정책</h2><Button $primary>설정 추가</Button></header>
        {settings.map((setting) => (
          <ListRow key={setting.name} $columns="1fr 180px 100px 100px">
            <div><strong>{setting.name}</strong><span>쇼핑몰 공통 정책</span></div>
            <span>{setting.value}</span>
            <Badge>{setting.status}</Badge>
            <Button>수정</Button>
          </ListRow>
        ))}
      </Panel>
    </Page>
  );
}
